import Dexie from "dexie";

// Crear instancia de la base de datos
const db = new Dexie("exceliaoneDB");

db.version(1).stores({
	users:
		"++id, No, username, email, [firstName+lastName], pendingSync, lastModified, lastSynced, deleted, Admin",
	clients:
		"++id, No, name, Tipo_Documento_SrI, Numero_Identificacion_fiscal, Customer_Price_Group, Telefono, Mobil, E_Mail, Direccion, Direccion_2, Poblacion, Cod_Postal, Pais, Contacto, POS_Discount, createdAt, lastModified, lastSynced, pendingSync, deleted, Source_Counter",
	clientAddresses:
		"++id, CustomerNo, Code, Name, Ciudad, Provincia, Email, Teléfono, lastSynced",
	products:
		"++id, No, description, Unit_Price, barcode, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoices:
		"++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, pendingSync, lastModified, lastSynced, deleted",
	invoiceLines:
		"++id, invoiceId, Line_No, Type, No, Description, Quantity, Unit_Price, Line_Discount_, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoicePaymentLines:
		"++id, invoiceId, Line_No, Document_Type, Document_No_, Payment_Method, Amount, pendingSync, lastModified, lastSynced, deleted",
	productLines:
		"++id, No, Line_No, Parent_Item_No, Type, Description, Quantity_per, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	formasPago: "++id, No, Code, Description, Dto, Tipo_Pago, lastSynced",
	turnos:
		"++id, DescripcionTurno, No, HorarioInicio, HorarioFin, pendingSync, lastModified, lastSynced, deleted",
	aperturaDeCaja:
		"++id, No, Cajero, FechaDeApertura, HoraDeApertura, ImporteDeApertura, Estado, Turno, Caja, pendingSync, lastModified, lastSynced, deleted",
	cajas:
		"++id, No, nombre, TPV, tpvNombre, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCaja:
		"++id, No, Cajero, ImporteDeApertura, FechaDeApertura, ImporteDeCierreBS, ImporteDeCierreUS, ImporteDeCierreEUR, ArqueoBS, ArqueoUS, ArqueoEUR, ArqueoEfectivoUS, ArqueoTarjetaUS, FechaDeCierre, Estado, idApertura, Comprobante_Tarjetas, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCajaDetalle:
		"++id, cierreId, Line_No, idCierre, idApertura, idFormaPago, DesFormaPago, MontoPago, TipoPago, pendingSync, lastModified, lastSynced, deleted",
	formaDePago:
		"++id, No, CodDivisa, CodFormaPago, ImporteAplicado, Cambio, ImporteTotal, ImporteRecibido, Vuelto, DocumentNo, AccountNo, Vendedor, FechaRegistro, pendingSync, lastModified, lastSynced, deleted",
	divisas:
		"++id, CodDivisa, Descripcion, Simbolo, pendingSync, lastModified, lastSynced, deleted",
	colegios: "++id, No, nombre, pendingSync, lastModified, lastSynced, deleted",
	tpvs: "++id, No, nombre, direccion, direccion2, ciudad, codigoPostal, provincia, pais, telefono, movil, email, sitioWeb, nifCif, contacto, notas, fechaAlta, locationCode, noSeries, pendingSync, lastModified, lastSynced, deleted",
	coupons:
		"++id, No, Description, Starting_Date, Ending_Date, Status, Active, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, pendingSync, lastModified, lastSynced, deleted",
	couponSalesPrices:
		"++id, couponNo, Item_No, Unit_Price, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponLineDiscounts:
		"++id, couponNo, Type, Code, Line_Discount_Percentage, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponDetails:
		"++id, couponNo, Detail_Type, No, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, Status, pendingSync, lastModified, lastSynced, deleted",
	salesPrices:
		"++id, Item_No, Sales_Type, Sales_Code, Minimum_Quantity, Unit_of_Measure_Code, Starting_Date, Ending_Date, Unit_Price, Currency_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	campaigns:
		"++id, No, Description, Starting_Date, Ending_Date, Sales_Prices, Line_Discounts, pendingSync, lastModified, lastSynced, deleted",
	empresa:
		"++id, Primary_Key, Name, Address, Address_2, City, County, Post_Code, SAT_Postal_Code, Country_Region_Code, Contact_Person, Phone_No, VAT_Registration_No, Federal_ID_No, EORI_Number, Industrial_Classification, Registration_No, Phone_No_2, Fax_No, E_Mail, Home_Page, Identificación_del_Rep_Legal, RUC_del_Contador, Cod_contribuyente_especial, Código_otorgado_por_DINARDAP, No_Establecimientos_inscritos, Auto_E_Invoice, Bank_Name, Bank_Branch_No, Bank_Account_No, Payment_Routing_No, Giro_No, SWIFT_Code, IBAN, Ship_to_Name, Ship_to_Address, Ship_to_Address_2, Ship_to_City, Ship_to_County, Ship_to_Post_Code, Ship_to_Country_Region_Code, Ship_to_Phone_No, Ship_to_Contact, Ship_to_UPS_Zone, Location_Code, Responsibility_Center, Check_Avail_Period_Calc, Check_Avail_Time_Bucket, Base_Calendar_Code, Customized_Calendar, Cal_Convergence_Time_Frame, QST_Registration_No, Tax_Area_Code, Tax_Exemption_No, Tax_Scheme, SAT_Tax_Regime_Classification, Provincial_Tax_Area_Code, RFC_Number, CURP_No, State_Inscription, Software_Identification_Code, GLN, Use_GLN_in_Electronic_Document, Allow_Blank_Payment_Info, BankAccountPostingGroup, Company_Badge, System_Indicator_Style, System_Indicator_Text, Experience, lastSynced, lastModified",
	environment:
		"++id, company, env, apiUrl, bcBaseUrl, grant_type, client_secret, client_id, scope, loginUrl, isActive, lastModified",
	syncMetadata: "++id, entity, lastSyncDate, lastSuccessfulSync, totalRecords, syncStatus, errorMessage",
});

// Versión 2: Agregar campos de sincronización a invoices
db.version(2).stores({
	users:
		"++id, No, username, email, [firstName+lastName], pendingSync, lastModified, lastSynced, deleted, Admin",
	clients:
		"++id, No, name, Tipo_Documento_SrI, Numero_Identificacion_fiscal, Customer_Price_Group, Telefono, Mobil, E_Mail, Direccion, Direccion_2, Poblacion, Cod_Postal, Pais, Contacto, POS_Discount, createdAt, lastModified, lastSynced, pendingSync, deleted, Source_Counter",
	clientAddresses:
		"++id, CustomerNo, Code, Name, Ciudad, Provincia, Email, Teléfono, lastSynced",
	products:
		"++id, No, description, Unit_Price, barcode, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoices:
		"++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime",
	invoiceLines:
		"++id, invoiceId, Line_No, Type, No, Description, Quantity, Unit_Price, Line_Discount_, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoicePaymentLines:
		"++id, invoiceId, Line_No, Document_Type, Document_No_, Payment_Method, Amount, pendingSync, lastModified, lastSynced, deleted",
	productLines:
		"++id, No, Line_No, Parent_Item_No, Type, Description, Quantity_per, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	formasPago: "++id, No, Code, Description, Dto, Tipo_Pago, lastSynced",
	turnos:
		"++id, DescripcionTurno, No, HorarioInicio, HorarioFin, pendingSync, lastModified, lastSynced, deleted",
	aperturaDeCaja:
		"++id, No, Cajero, FechaDeApertura, HoraDeApertura, ImporteDeApertura, Estado, Turno, Caja, pendingSync, lastModified, lastSynced, deleted",
	cajas:
		"++id, No, nombre, TPV, tpvNombre, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCaja:
		"++id, No, Cajero, ImporteDeApertura, FechaDeApertura, ImporteDeCierreBS, ImporteDeCierreUS, ImporteDeCierreEUR, ArqueoBS, ArqueoUS, ArqueoEUR, ArqueoEfectivoUS, ArqueoTarjetaUS, FechaDeCierre, Estado, idApertura, Comprobante_Tarjetas, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCajaDetalle:
		"++id, cierreId, Line_No, idCierre, idApertura, idFormaPago, DesFormaPago, MontoPago, TipoPago, pendingSync, lastModified, lastSynced, deleted",
	formaDePago:
		"++id, No, CodDivisa, CodFormaPago, ImporteAplicado, Cambio, ImporteTotal, ImporteRecibido, Vuelto, DocumentNo, AccountNo, Vendedor, FechaRegistro, pendingSync, lastModified, lastSynced, deleted",
	divisas:
		"++id, CodDivisa, Descripcion, Simbolo, pendingSync, lastModified, lastSynced, deleted",
	colegios: "++id, No, nombre, pendingSync, lastModified, lastSynced, deleted",
	tpvs: "++id, No, nombre, direccion, direccion2, ciudad, codigoPostal, provincia, pais, telefono, movil, email, sitioWeb, nifCif, contacto, notas, fechaAlta, locationCode, noSeries, margenCierre, pendingSync, lastModified, lastSynced, deleted",
	coupons:
		"++id, No, Description, Starting_Date, Ending_Date, Status, Active, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, pendingSync, lastModified, lastSynced, deleted",
	couponSalesPrices:
		"++id, couponNo, Item_No, Unit_Price, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponLineDiscounts:
		"++id, couponNo, Type, Code, Line_Discount_Percentage, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponDetails:
		"++id, couponNo, Detail_Type, No, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, Status, pendingSync, lastModified, lastSynced, deleted",
	salesPrices:
		"++id, Item_No, Sales_Type, Sales_Code, Minimum_Quantity, Unit_of_Measure_Code, Starting_Date, Ending_Date, Unit_Price, Currency_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	campaigns:
		"++id, No, Description, Starting_Date, Ending_Date, Sales_Prices, Line_Discounts, pendingSync, lastModified, lastSynced, deleted",
	empresa:
		"++id, Primary_Key, Name, Address, Address_2, City, County, Post_Code, SAT_Postal_Code, Country_Region_Code, Contact_Person, Phone_No, VAT_Registration_No, Federal_ID_No, EORI_Number, Industrial_Classification, Registration_No, Phone_No_2, Fax_No, E_Mail, Home_Page, Identificación_del_Rep_Legal, RUC_del_Contador, Cod_contribuyente_especial, Código_otorgado_por_DINARDAP, No_Establecimientos_inscritos, Auto_E_Invoice, Bank_Name, Bank_Branch_No, Bank_Account_No, Payment_Routing_No, Giro_No, SWIFT_Code, IBAN, Ship_to_Name, Ship_to_Address, Ship_to_Address_2, Ship_to_City, Ship_to_County, Ship_to_Post_Code, Ship_to_Country_Region_Code, Ship_to_Phone_No, Ship_to_Contact, Ship_to_UPS_Zone, Location_Code, Responsibility_Center, Check_Avail_Period_Calc, Check_Avail_Time_Bucket, Base_Calendar_Code, Customized_Calendar, Cal_Convergence_Time_Frame, QST_Registration_No, Tax_Area_Code, Tax_Exemption_No, Tax_Scheme, SAT_Tax_Regime_Classification, Provincial_Tax_Area_Code, RFC_Number, CURP_No, State_Inscription, Software_Identification_Code, GLN, Use_GLN_in_Electronic_Document, Allow_Blank_Payment_Info, BankAccountPostingGroup, Company_Badge, System_Indicator_Style, System_Indicator_Text, Experience, lastSynced, lastModified",
	environment:
		"++id, company, env, apiUrl, bcBaseUrl, grant_type, client_secret, client_id, scope, loginUrl, isActive, lastModified",
	syncMetadata: "++id, entity, lastSyncDate, lastSuccessfulSync, totalRecords, syncStatus, errorMessage",
}).upgrade(trans => {
	// Migración para agregar campos por defecto a facturas existentes
	return trans.invoices.toCollection().modify(invoice => {
		invoice.syncing = false;
		invoice.syncStartTime = null;
	});
});

// Versión 3: Agregar campos de contacto a invoices (E_Mail, Telefono, Mobil)
db.version(3).stores({
	users:
		"++id, No, username, email, [firstName+lastName], pendingSync, lastModified, lastSynced, deleted, Admin",
	clients:
		"++id, No, name, Tipo_Documento_SrI, Numero_Identificacion_fiscal, Customer_Price_Group, Telefono, Mobil, E_Mail, Direccion, Direccion_2, Poblacion, Cod_Postal, Pais, Contacto, POS_Discount, createdAt, lastModified, lastSynced, pendingSync, deleted, Source_Counter",
	clientAddresses:
		"++id, CustomerNo, Code, Name, Ciudad, Provincia, Email, Teléfono, lastSynced",
	products:
		"++id, No, description, Unit_Price, barcode, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoices:
		"++id, No, Document_Type, Sell_to_Customer_No_, Posting_No, draftNo, Colegio, Bill_to_Name, Bill_to_Address, Bill_to_City, VAT_Registration_No_, Bill_to_Country_Region_Code, Ship_to_Code, Tipo_Documento_SrI, E_Mail, Telefono, Mobil, caja, clientLocalId, turno, Dto, importeDto, Cupon, Tipo_Detalle, No_Detalle, pendingSync, lastModified, lastSynced, deleted, syncing, syncStartTime",
	invoiceLines:
		"++id, invoiceId, Line_No, Type, No, Description, Quantity, Unit_Price, Line_Discount_, PorIva, pendingSync, lastModified, lastSynced, deleted",
	invoicePaymentLines:
		"++id, invoiceId, Line_No, Document_Type, Document_No_, Payment_Method, Amount, pendingSync, lastModified, lastSynced, deleted",
	productLines:
		"++id, No, Line_No, Parent_Item_No, Type, Description, Quantity_per, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	formasPago: "++id, No, Code, Description, Dto, Tipo_Pago, lastSynced",
	turnos:
		"++id, DescripcionTurno, No, HorarioInicio, HorarioFin, pendingSync, lastModified, lastSynced, deleted",
	aperturaDeCaja:
		"++id, No, Cajero, FechaDeApertura, HoraDeApertura, ImporteDeApertura, Estado, Turno, Caja, pendingSync, lastModified, lastSynced, deleted",
	cajas:
		"++id, No, nombre, TPV, tpvNombre, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCaja:
		"++id, No, Cajero, ImporteDeApertura, FechaDeApertura, ImporteDeCierreBS, ImporteDeCierreUS, ImporteDeCierreEUR, ArqueoBS, ArqueoUS, ArqueoEUR, ArqueoEfectivoUS, ArqueoTarjetaUS, FechaDeCierre, Estado, idApertura, Comprobante_Tarjetas, pendingSync, lastModified, lastSynced, deleted",
	cierreDeCajaDetalle:
		"++id, cierreId, Line_No, idCierre, idApertura, idFormaPago, DesFormaPago, MontoPago, TipoPago, pendingSync, lastModified, lastSynced, deleted",
	formaDePago:
		"++id, No, CodDivisa, CodFormaPago, ImporteAplicado, Cambio, ImporteTotal, ImporteRecibido, Vuelto, DocumentNo, AccountNo, Vendedor, FechaRegistro, pendingSync, lastModified, lastSynced, deleted",
	divisas:
		"++id, CodDivisa, Descripcion, Simbolo, pendingSync, lastModified, lastSynced, deleted",
	colegios: "++id, No, nombre, pendingSync, lastModified, lastSynced, deleted",
	tpvs: "++id, No, nombre, direccion, direccion2, ciudad, codigoPostal, provincia, pais, telefono, movil, email, sitioWeb, nifCif, contacto, notas, fechaAlta, locationCode, noSeries, margenCierre, pendingSync, lastModified, lastSynced, deleted",
	coupons:
		"++id, No, Description, Starting_Date, Ending_Date, Status, Active, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, pendingSync, lastModified, lastSynced, deleted",
	couponSalesPrices:
		"++id, couponNo, Item_No, Unit_Price, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponLineDiscounts:
		"++id, couponNo, Type, Code, Line_Discount_Percentage, Currency_Code, Starting_Date, Ending_Date, Minimum_Quantity, Unit_of_Measure_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	couponDetails:
		"++id, couponNo, Detail_Type, No, Discount_Percentage, Discount_Amount, Total_Discounted_Amount, Status, pendingSync, lastModified, lastSynced, deleted",
	salesPrices:
		"++id, Item_No, Sales_Type, Sales_Code, Minimum_Quantity, Unit_of_Measure_Code, Starting_Date, Ending_Date, Unit_Price, Currency_Code, Variant_Code, pendingSync, lastModified, lastSynced, deleted",
	campaigns:
		"++id, No, Description, Starting_Date, Ending_Date, Sales_Prices, Line_Discounts, pendingSync, lastModified, lastSynced, deleted",
	empresa:
		"++id, Primary_Key, Name, Address, Address_2, City, County, Post_Code, SAT_Postal_Code, Country_Region_Code, Contact_Person, Phone_No, VAT_Registration_No, Federal_ID_No, EORI_Number, Industrial_Classification, Registration_No, Phone_No_2, Fax_No, E_Mail, Home_Page, Identificación_del_Rep_Legal, RUC_del_Contador, Cod_contribuyente_especial, Código_otorgado_por_DINARDAP, No_Establecimientos_inscritos, Auto_E_Invoice, Bank_Name, Bank_Branch_No, Bank_Account_No, Payment_Routing_No, Giro_No, SWIFT_Code, IBAN, Ship_to_Name, Ship_to_Address, Ship_to_Address_2, Ship_to_City, Ship_to_County, Ship_to_Post_Code, Ship_to_Country_Region_Code, Ship_to_Phone_No, Ship_to_Contact, Ship_to_UPS_Zone, Location_Code, Responsibility_Center, Check_Avail_Period_Calc, Check_Avail_Time_Bucket, Base_Calendar_Code, Customized_Calendar, Cal_Convergence_Time_Frame, QST_Registration_No, Tax_Area_Code, Tax_Exemption_No, Tax_Scheme, SAT_Tax_Regime_Classification, Provincial_Tax_Area_Code, RFC_Number, CURP_No, State_Inscription, Software_Identification_Code, GLN, Use_GLN_in_Electronic_Document, Allow_Blank_Payment_Info, BankAccountPostingGroup, Company_Badge, System_Indicator_Style, System_Indicator_Text, Experience, lastSynced, lastModified",
	environment:
		"++id, company, env, apiUrl, bcBaseUrl, grant_type, client_secret, client_id, scope, loginUrl, isActive, lastModified",
	syncMetadata: "++id, entity, lastSyncDate, lastSuccessfulSync, totalRecords, syncStatus, errorMessage",
}).upgrade(() => {
	// No-op: solo añadimos nuevos índices/campos opcionales
});

// Funciones helper para gestionar el lastSourceCode
export const getLastSourceCode = async (entity = "products") => {
	try {
		const metadata = await db.syncMetadata
			.where("entity")
			.equals(entity)
			.first();
		return metadata ? metadata.lastSourceCode : -1;
	} catch (error) {
		console.error(`Error al obtener lastSourceCode para ${entity}:`, error);
		return -1;
	}
};

export const setLastSourceCode = async (sourceCode, entity = "products") => {
	try {
		const metadata = await db.syncMetadata
			.where("entity")
			.equals(entity)
			.first();
		if (metadata) {
			await db.syncMetadata.update(metadata.id, {
				lastSourceCode: sourceCode,
				lastSyncDate: new Date(),
			});
		} else {
			await db.syncMetadata.add({
				entity: entity,
				lastSourceCode: sourceCode,
				lastSyncDate: new Date(),
			});
		}
		console.log(`LastSourceCode actualizado para ${entity}: ${sourceCode}`);
	} catch (error) {
		console.error(`Error al actualizar lastSourceCode para ${entity}:`, error);
	}
};

// Función para actualizar el estado de sincronización de un modelo
export const updateSyncStatus = async (entity, success, totalRecords = 0, errorMessage = null) => {
	try {
		const metadata = await db.syncMetadata
			.where("entity")
			.equals(entity)
			.first();

		const updateData = {
			lastSyncDate: new Date(),
			syncStatus: success ? 'success' : 'error',
			totalRecords: success ? totalRecords : (metadata?.totalRecords || 0),
			errorMessage: errorMessage
		};

		if (success) {
			updateData.lastSuccessfulSync = new Date();
		}

		if (metadata) {
			await db.syncMetadata.update(metadata.id, updateData);
		} else {
			await db.syncMetadata.add({
				entity: entity,
				...updateData
			});
		}

		console.log(`Estado de sincronización actualizado para ${entity}: ${success ? 'éxito' : 'error'}`);
	} catch (error) {
		console.error(`Error al actualizar estado de sincronización para ${entity}:`, error);
	}
};

// Función para obtener el estado de sincronización de todos los modelos
export const getAllSyncStatus = async () => {
	try {
		const allMetadata = await db.syncMetadata.toArray();

		// Definir todos los modelos disponibles
		const allModels = [
			{ key: 'users', name: 'Usuarios', icon: '👤' },
			{ key: 'clients', name: 'Clientes', icon: '👥' },
			{ key: 'products', name: 'Productos', icon: '📦' },
			{ key: 'productLines', name: 'Líneas de Producto', icon: '📋' },
			{ key: 'invoices', name: 'Facturas', icon: '📄' },
			{ key: 'turnos', name: 'Turnos', icon: '🕐' },
			{ key: 'cajas', name: 'Cajas', icon: '💰' },
			{ key: 'aperturaDeCaja', name: 'Aperturas de Caja', icon: '🔓' },
			{ key: 'cierreDeCaja', name: 'Cierres de Caja', icon: '🔒' },
			{ key: 'formasPago', name: 'Formas de Pago', icon: '💳' },
			{ key: 'colegios', name: 'Colegios', icon: '🏫' },
			{ key: 'tpvs', name: 'Tiendas', icon: '🏪' },
			{ key: 'coupons', name: 'Cupones', icon: '🎫' },
			{ key: 'campaigns', name: 'Campañas', icon: '📢' },
			{ key: 'salesPrices', name: 'Precios de Venta', icon: '💰' },
			{ key: 'empresa', name: 'Empresa', icon: '🏢' }
		];

		const result = allModels.map(model => {
			const metadata = allMetadata.find(m => m.entity === model.key);
			return {
				...model,
				lastSyncDate: metadata?.lastSyncDate || null,
				lastSuccessfulSync: metadata?.lastSuccessfulSync || null,
				totalRecords: metadata?.totalRecords || 0,
				syncStatus: metadata?.syncStatus || 'never',
				errorMessage: metadata?.errorMessage || null
			};
		});

		return result;
	} catch (error) {
		console.error('Error al obtener estado de sincronización:', error);
		return [];
	}
};

// Función para obtener el conteo de registros de una tabla
export const getTableCount = async (tableName) => {
	try {
		if (db[tableName]) {
			return await db[tableName].count();
		}
		return 0;
	} catch (error) {
		console.error(`Error al contar registros en ${tableName}:`, error);
		return 0;
	}
};

// Función para borrar todos los maestros
export const clearAllMasterData = async () => {
	try {
		console.log("🗑️ Iniciando limpieza de todos los maestros...");

		// Definir las tablas de maestros a limpiar
		const masterTables = [
			"clients",
			"products",
			"productLines",
			"colegios",
			"tpvs",
			"turnos",
			"cajas",
			"coupons",
			"couponSalesPrices",
			"couponLineDiscounts",
			"couponDetails",
			"campaigns",
			"salesPrices",
			"formasPago",
			"empresa",
			"users", // Incluir usuarios excepto el actual
		];

		// Obtener el usuario actual para no borrarlo
		const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
		console.log("👤 Usuario actual preservado:", currentUser.username || "N/A");

		// Limpiar cada tabla de maestros
		const results = {};

		for (const tableName of masterTables) {
			try {
				if (tableName === "users" && currentUser.id) {
					// Para usuarios, contar primero y luego borrar todos excepto el actual
					const countToDelete = await db[tableName]
						.where("id")
						.notEqual(currentUser.id)
						.count();
					// const deletedCount = await db[tableName].where('id').notEqual(currentUser.id).delete();
					results[tableName] = countToDelete;
					console.log(
						`✅ ${tableName}: ${countToDelete} registros eliminados (preservado usuario actual)`
					);
				} else {
					// Para otras tablas, contar primero y luego borrar todo
					const countBeforeDelete = await db[tableName].count();
					await db[tableName].clear();
					results[tableName] = countBeforeDelete;
					console.log(
						`✅ ${tableName}: ${countBeforeDelete} registros eliminados`
					);
				}
			} catch (error) {
				console.error(`❌ Error limpiando tabla ${tableName}:`, error);
				results[tableName] = `Error: ${error.message}`;
			}
		}

		// Resetear metadata de sincronización
		try {
			await db.syncMetadata.clear();
			console.log("✅ Metadata de sincronización reseteada");

			// Recrear metadata básica
			await db.syncMetadata.add({
				entity: "products",
				lastSourceCode: -1,
				lastSyncDate: null,
			});
		} catch (error) {
			console.error("❌ Error reseteando metadata:", error);
		}

		// Calcular totales
		const totalDeleted = Object.values(results)
			.filter((count) => typeof count === "number")
			.reduce((sum, count) => sum + count, 0);

		const tablesWithErrors = Object.entries(results)
			.filter(([table, result]) => typeof result === "string")
			.map(([table, error]) => `${table}: ${error}`);

		console.log("🎉 Limpieza de maestros completada:", results);
		console.log(`📊 Total registros eliminados: ${totalDeleted}`);

		if (tablesWithErrors.length > 0) {
			console.warn("⚠️ Tablas con errores:", tablesWithErrors);
		}

		return {
			success: true,
			results: results,
			totalDeleted: totalDeleted,
			tablesWithErrors: tablesWithErrors,
			message: `Todos los maestros han sido eliminados correctamente. Total: ${totalDeleted} registros.`,
		};
	} catch (error) {
		console.error("❌ Error durante la limpieza de maestros:", error);
		return {
			success: false,
			error: error.message,
			message: "Error durante la limpieza de maestros",
		};
	}
};

export default db;
